/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  class freeProducts extends HTMLElement {
    constructor() {
      super();

      this.radios = this.querySelectorAll('[name="free_product"]')
      const _this = this

      this.radios.forEach(r=> {
        r.addEventListener('change', function(e) {
            _this.onChange(r)
        })
      })
    }

    onChange(r) {
      const _this = this
      if (r.checked) {
        const parent = r.closest('.radio-wrap')
        const quickAdd = parent.querySelector('[data-add-to-cart]')

        quickAdd?.click()
        const freeProductGrid = document.querySelector('.free-products-grid')
        freeProductGrid?.style.setProperty('pointer-events', 'none')
      }
    }
  }
  customElements.define('free-products', freeProducts);


  document.addEventListener('theme:cart:change', function(e) {

    // if (document.querySelector('free-products') == null) return;

      fetch('/cart.js').then(response => {
        return response.json();
      })
      .then(cartData => {
        const addonIds = [];
        const cartItems = cartData.items
        const cartTotal = cartData.total_price
        const cartThreshold = Number(document.querySelector('[data-cart-free-holder][data-threshold]').dataset.threshold)

        cartItems.forEach(item => {
          const properties = item.properties;
          Object.keys(properties).forEach(key => {
              if (key.includes('_free_product')) {
                  addonIds.push({ [item.variant_id]: 0 });
              }
          });
        });


        if (addonIds.length == 0) return;
        if (cartTotal >= cartThreshold && addonIds.length > 0 ) return;

        var formData = new FormData();

        
        addonIds.forEach(addon => {
            Object.entries(addon).forEach(([id, quantity]) => {
                formData.append(`updates[${id}]`, quantity);
            });
        });

        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then((response) => {
          document.querySelector('cart-items')?.getCart()
        })
      })
      .catch(error => {
        console.error('Error fetching shopping cart data:', error);
      });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
